@if (isAppReady$ | async) {
  <main class="d-flex flex-column h-100" [class.app-shell--fill]="isFillViewportRoute$ | async">
    <app-header></app-header>
    <div class="flex-grow-1" [class.app-shell-content]="isFillViewportRoute$ | async">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </main>
} @else {
  <main class="h-100">
    <router-outlet></router-outlet>
  </main>
}

<wnr-notification-toast-container />
